class EditProjectInfoModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http, $timeout, projectNumber, projectName, contractId, contracts, projectUrl) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$timeout = $timeout;
    this.projectUrl = projectUrl;
    
    // Initialize form values immediately
    this.projectNumber = projectNumber || '';
    this.projectName = projectName || '';
    
    // Store original values for change detection
    this.originalProjectNumber = projectNumber || '';
    this.originalProjectName = projectName || '';
    this.originalContractId = contractId;
    
    // Initialize contract list
    this.contracts = contracts || [];
    this.selectedContract = null;
    
    if (contractId && this.contracts && this.contracts.length > 0) {
      this.selectedContract = this.contracts.find(c => c.id === contractId);
    }
    
    // Use $timeout as a backup to ensure values are set if they weren't picked up initially
    this.$timeout(() => {
      // Re-set form values to ensure they're bound
      if (!this.projectNumber && projectNumber) {
        this.projectNumber = projectNumber;
      }
      if (!this.projectName && projectName) {
        this.projectName = projectName;
      }
      
      // Re-set contract if not already set
      if (!this.selectedContract && contractId && this.contracts && this.contracts.length > 0) {
        this.selectedContract = this.contracts.find(c => c.id === contractId);
      }
    }, 100);
  }
  
  onContractSelected(contract) {
    this.selectedContract = contract;
  }
  
  hasChanges() {
    const numberChanged = this.projectNumber !== this.originalProjectNumber;
    const nameChanged = this.projectName !== this.originalProjectName;
    const contractChanged = this.selectedContract && this.selectedContract.id !== this.originalContractId;
    
    return numberChanged || nameChanged || contractChanged;
  }
  
  save() {
    if (!this.hasChanges()) {
      this.$uibModalInstance.dismiss();
      return;
    }
    
    const updates = {};
    
    // Update project number if changed
    if (this.projectNumber !== this.originalProjectNumber) {
      updates.number = this.projectNumber;
    }
    
    // Update project name if changed
    if (this.projectName !== this.originalProjectName) {
      updates.name = this.projectName;
    }
    
    // Update contract if changed
    if (this.selectedContract && this.selectedContract.id !== this.originalContractId) {
      updates.contractId = this.selectedContract.id;
    }
    
    // Send updates
    if (Object.keys(updates).length > 0) {
      this.$http.patch(this.projectUrl, updates, { withCredentials: true })
        .then(() => {
          // Return updated values
          this.$uibModalInstance.close({
            number: this.projectNumber,
            name: this.projectName,
            contractId: this.selectedContract ? this.selectedContract.id : this.originalContractId,
            contractName: this.selectedContract ? this.selectedContract.contractName : null
          });
        })
        .catch((error) => {
          console.error('Error updating project information:', error);
          // Could show error message here
        });
    } else {
      this.$uibModalInstance.dismiss();
    }
  }
  
  cancel() {
    this.$uibModalInstance.dismiss();
  }
}

export default EditProjectInfoModalController;




// WEBPACK FOOTER //
// ./client/common/modals/editProjectInfoModal/editProjectInfoModal.controller.js